import classnames from 'classnames';
import autobind from 'core-decorators/lib/autobind';

import runOnce from 'shared/utils/run-once';

import { visibleInViewPort } from 'widget/components/mobile-carousel/visible-on-screen';

import styles from './first-time-track-animation.styl';


const firstTimeTrackAnimation = WrappedComponent => {

  @visibleInViewPort
  class FirstTimeTrackAnimation extends React.Component {

    static propTypes = {
      isVisibleInViewport: React.PropTypes.bool,
      trackClassName: React.PropTypes.string,
    };

    static defaultProps = {
      isVisibleInViewport: false,
    };

    state = {
      isTrackStarted: false,
    };

    _alreadyWasShown = false;

    @autobind
    @runOnce
    updateTrackStarted() {
      this.setState({
        isTrackStarted: true,
      });
    }

    render() {
      const { trackClassName, isVisibleInViewport } = this.props;
      const { isTrackStarted } = this.state;

      // If track was already started than don't add track class name because it lead to a bug on iOS
      // https://trello.com/c/wGyLqjFd
      const shouldApplyAnimationClassName = !isTrackStarted && (this._alreadyWasShown || isVisibleInViewport);

      const mergedTrackClassName = classnames(
        trackClassName,
        {
          [styles['start-animation']]: shouldApplyAnimationClassName,
        },
      );

      if (shouldApplyAnimationClassName) {
        this._alreadyWasShown = true;
      }

      return (
        <WrappedComponent {...this.props}
                          onUserStartedTracking={this.updateTrackStarted}
                          trackClassName={mergedTrackClassName} />
      );
    }
  }

  FirstTimeTrackAnimation.WixWrappedComponent = WrappedComponent;

  return FirstTimeTrackAnimation;
};

export default firstTimeTrackAnimation;



// WEBPACK FOOTER //
// ./src/widget/components/players-list-slidable/first-time-track-animation.js